<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-6 mx-auto">
        <Card>
          <div
            v-if="alert"
            class="alert alert-danger"
          >
            Please fill all the keywords.
          </div>
          <label>ENTER YOUR KEYWORD</label>
          <div
            v-for="(keyword, index) in keywordsData"
            :id="index"
            :key="index"
            class="input-group mb-1"
          >
            <input
              v-model="keywordsData[index]"
              type="text"
              class="form-control"
              placeholder="Keyword here…"
              :disabled="isDisabled(keywordsData[index])"
              @keyup.enter="nextStep()"
            >
            <div class="input-group-prepend">
              <div
                v-if="index > 1 || Object.keys(keywords).length > 0"
                class="input-group-text"
              >
                <button
                  class="btn btn-sm btn-danger remove-button"
                  @click="removeKeywordFromList(index)"
                >
                  <i
                    class="fa fa-times"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
          <div v-if="shouldShowAddMore">
            <button
              class="add-more w-100 pt-1 pb-1"
              @click="addKeyword"
            >
              Add More keywords
            </button>
          </div>
          <button
            class="btn btn-lg btn-gradient-primary btn-oval w-100 mt-2 pt-2 pb-2"
            @click="nextStep()"
          >
            Analyze
          </button>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs';
import SpreadsheetService from '@/services/SpreadsheetService';
import { MAX_KEYWORDS } from '@/config/constants'

export default {
  head: {
    title: {
      inner: 'SEO Analyzer: Free Analysis Tool & Audit Report'
    },
    meta: [
      { name: 'robots', content: "noindex,nofollow" }
    ],
    link: [
      { rel: 'canonical', href: 'https://www.seo-browser.com', id: 'canonical' },
    ]
  },

  data() {
    return {
      keywordsData: {
        0: '',
      },
      alert: false
    }
  },

  computed: {

    ...mapState('app', ['clientIp', 'url']),

    ...mapState('keyword', ['keywords']),

    shouldShowAddMore() {
      return Object.keys(this.keywordsData).length < MAX_KEYWORDS
    },

    keywordsCount() {
      return Object.keys(this.keywordsData).length
    }

  },

  mounted() {

    const { domain } = this.$route.params;

    this.updateURL(domain);

    this.setClientIp();
    
    if(Object.keys(this.keywords).length > 0) {
      Object.keys(this.keywords).forEach( (keyword,index) => this.$set(this.keywordsData, index, keyword))
    }

  },

  methods: {

    ...mapActions('app', ['updateURL', 'setClientIp']),

    ...mapActions('keyword', ['updateKeywords', 'removeKeyword']),

    addKeyword() {
      if (this.keywordsCount <= MAX_KEYWORDS) {
        this.$set(this.keywordsData, this.keywordsCount + 1, '')
      }
    },

    removeKeywordFromList(index) {
      const keyword = this.keywordsData[index];

      this.removeKeyword(keyword);

      this.$delete(this.keywordsData, index)

      if (this.keywordsCount === 0) {
        this.keywordsData = { 0: '' };
      }
    },

    isDisabled(keyword) {
      return Object.keys(this.keywords).includes(keyword)
    },

    nextStep() {
      Object.keys(this.keywordsData).forEach((key) => {
        // Checks if object has empty string, if there's an empty string, then sets alert state to true
        this.alert = this.keywordsData[key] === ''
      })
      if (!this.alert) {
        const existingKeywords = Object.keys(this.keywords);

        const keywords = Object.values(this.keywordsData);

        const newKeywords = this.arrayDiff(keywords, existingKeywords)

        this.updateKeywords(newKeywords)

        this.$router.push({ name: 'results', query: { keywords: Object.keys(this.keywords).join(',') } })

        if (newKeywords.length > 0){
          this.pushKeywordsToSpreadsheet(Object.keys(this.keywords));
        }
      }
    },

    async pushKeywordsToSpreadsheet(keywords) {

      try {
        const row = {
          'Date': dayjs().format('MM-DD-YYYY'),
          'Time': dayjs(new Date().toLocaleString("en-US", { timeZone: "America/New_York"} )).format('h:mm a'),
          'URL': this.url,
          'Keyword 1': keywords[0] ? keywords[0] : '-',
          'Keyword 2': keywords[1] ? keywords[1] : '-',
          'Keyword 3': keywords[2] ? keywords[2] : '-',
          'IP Address': this.clientIp,
          'Tool': 'http://seo-browser.com'
        };

        await SpreadsheetService.pushToDefaultSpreadsheet(row)

      } catch (error) {
        throw new Error(error);
      }
    },

    initialState() {
      Object.keys(this.keywordsData).forEach((key) => {
        this.removeKeywordFromList(key);
      });

      this.keywordsData = {
        0: ''
      };
      this.alert = false;
    },
  }
}
</script>

<style scoped lang="scss">
.add-more {
  border: 2px dashed #dbdbdb;
  color: #929292;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  height: 42px;
  background: transparent;
}
label {
  color: #000000;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 1rem;
}
.input-group {
  input {
    border: 1px solid #dbdbdb;
    border-radius: 2px;
    &::placeholder {
      color: #000000;
      font-size: 16px;
      font-family: Montserrat, sans-serif;
      font-weight: 300;
    }
  }
  .input-group-prepend {
    background-color: #fff;
    .input-group-text {
      border-left: none;
      .remove-button {
        height: 2.7rem;
        width: 2.7rem;
        border-radius: 50%;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0;
        i {
          font-size: 11px;
          position: relative;
          left: 1px;
        }
      }
    }
  }
}
</style>


